import React from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollToTop from "common/ScrollToTop";
import store from "state/store";
import NotFoundPage from "pages/404";
import { TimerProvider } from "components/common/wrappers/withTimer";
import { PopupProvider } from "components/common/wrappers/withPopup";
import { BreakpointProvider } from "components/common/wrappers/withBreakpoint";
import { PromoProvider } from "components/common";
import LandingPage from "./pages/LandingPage";
import AILandingPage from "./pages/AILandingPage";
import Careers from "./pages/Careers";
import FAQ from "./pages/Faq";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import About from "./pages/About";
import Legal from "./pages/Legal";
import Support from "./pages/Support";
import Ambassador from "./pages/Ambassador";
import Comparison from "./pages/Comparison";
import Boost from "./pages/Boost/TomoBoost";
import BoostFAQ from "./pages/BoostFaq";
import BoostBlog from "./pages/BoostBlog";
import BoostPricing from "./pages/Boost/BoostPricing";
import BoostCheckout from "./pages/Boost/BoostCheckout";
import ApplicationTroubleshooting from "./pages/ApplicationTroubleshooting";

const App = () => {
  return (
    <Router>
      <Provider store={store}>
        <BreakpointProvider>
          <PromoProvider>
            <TimerProvider>
              <PopupProvider>
                <Helmet>
                  {/* <!-- Hotjar Tracking Code for https://www.tomocredit.com/ --> */}
                  {/* <script>
                  {`(function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:1964339,hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
                </script> */}
                  {/* <!-- Tomocredit Zendesk Widget script --> */}
                  {/* <script
                  id="ze-snippet"
                  src="https://static.zdassets.com/ekr/snippet.js?key=08a99751-16ff-413b-967d-0613e4d8ef84"
                /> */}
                </Helmet>
                <ScrollToTop />
                <Switch>
                  <Route
                    sensitive
                    path="/:anything*([A-Z]):anything*/"
                    render={(props) => (
                      <Redirect to={`${props.location.pathname.toLowerCase()}`} />
                    )}
                  />
                  <Route exact path="/" component={LandingPage} />
                  {/* <Route exact path="/securedcard" component={SecuredCardReserved} /> */}
                  <Route exact path="/about" component={About} />
                  <Route
                    exact
                    path="/resume"
                    component={() => {
                      window.location = `${process.env.REACT_APP_DOMAIN}/register/login`;
                    }}
                  />
                  <Route exact path="/boost" component={Boost} />
                  <Route exact path="/boost-faq" component={BoostFAQ} />
                  <Route exact path="/boost-pricing" component={BoostPricing} />
                  <Route exact path="/boost-checkout" component={BoostCheckout} />
                  <Route exact path="/boost-blog" component={BoostBlog} />
                  <Route exact path="/careers" component={Careers} />
                  <Route exact path="/faq" component={FAQ} />
                  <Route exact path="/privacypolicy" component={PrivacyPolicy} />
                  <Route exact path="/ai" component={AILandingPage} />
                  {/* <Route
                    exact
                    path="/cardholderagreement"
                    component={CardholderAgreement}
                  /> */}
                  <Route exact path="/legal" component={Legal} />
                  <Route exact path="/support" component={Support} />
                  <Route exact path="/ambassador" component={Ambassador} />
                  <Route exact path="/thecard" component={Comparison} />
                  <Route
                    exact
                    path="/application-troubleshooting"
                    component={ApplicationTroubleshooting}
                  />
                  {/* <Route exact path="/passwordrecovery" component={PasswordRecovery} />
                  <Route exact path="/confirmpassword" component={ConfirmPassword} /> */}

                  <Route component={NotFoundPage} />
                </Switch>
              </PopupProvider>
            </TimerProvider>
          </PromoProvider>
        </BreakpointProvider>
      </Provider>
    </Router>
  );
};

export default App;
